/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_TRANSACTIONS(state, transactions) {
    state.transactions = transactions
  },
  REMOVE_RECORD(state, itemId) {
      const transactionIndex = state.transactions.findIndex((u) => u.id == itemId)
      state.transactions.splice(transactionIndex, 1)
  },
}
